/**
 * Public dealer profile route resolution (Dealer Profile M3).
 */
import { SEO_PAGE_TYPES } from "../../constants/seoPageConstants";
import { getSeoPageConfig } from "../../services/seoPageService";
import { normalizeDealerSlug } from "./dealerSlug";

export const DEALER_PROFILE_ROUTE_STATUS = {
  FOUND: "found",
  NOT_FOUND: "not_found",
  HIDDEN: "hidden",
  INACTIVE: "inactive",
  SUSPENDED: "suspended",
  REJECTED: "rejected",
  INVALID_SLUG: "invalid_slug",
  ERROR: "error",
};

/**
 * City SEO pages use `/concesionarios/:citySlug` (e.g. medellin, envigado).
 * Dealer profiles share the same path prefix — disambiguate via static SEO registry.
 */
export function isDealerCitySeoSlug(slug) {
  const normalized = normalizeDealerSlug(slug);
  if (!normalized) return false;
  const config = getSeoPageConfig(`/concesionarios/${normalized}`);
  return config?.pageType === SEO_PAGE_TYPES.DEALER_CITY;
}

export function resolveConcesionariosSlugRoute(slug) {
  if (isDealerCitySeoSlug(slug)) return "dealer_city_seo";
  return "dealer_profile";
}
